module.exports = __webpack_public_path__ + "static/produto4-28c9bd7378af5e2da89e272757ea83e0.jpg";